import logger from 'js/app/loggerSingleton';

import { SEARCH_MAIN_INDEX_ID } from 'bundles/search-common/constants';
import { useSearch } from 'bundles/search-common/providers/SearchContext';
import type { SearchFacet } from 'bundles/search-common/providers/searchTypes';

type FacetResult = {
  facet?: SearchFacet;
} & {
  isLoading: boolean;
};

export const useSearchFacet = (facetName: string): FacetResult => {
  const searchProviderContext = useSearch();

  if (!searchProviderContext) {
    logger.warn('useSearchFacet expected SearchProvider');
  }

  const { getSearchResults, isLoading } = searchProviderContext;
  const searchData = getSearchResults(SEARCH_MAIN_INDEX_ID);
  const { facets: searchFacets } = searchData || {};

  const facet = searchFacets?.find((searchFacet) => searchFacet.name === facetName);

  return {
    facet,
    isLoading: Boolean(isLoading),
  };
};
